/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
/** @jsxImportSource solid-js */
import { customElement } from 'solid-element';
import CustomDatePicker, {
  type CustomDatePickerProps,
} from './CustomDatePicker';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-custom-datepicker': Partial<HTMLElement> &
        CustomDatePickerProps &
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Partial<{ ref: any }>;
    }
  }
}

export function defineSolidCustomDatePicker(): void {
  customElement(
    'tc-custom-datepicker',
    {
      // Include ALL component properties with default values
      name: undefined as unknown as string,
      label: undefined as unknown as string,
      setFocus: false,
      id: undefined as unknown as string | undefined,
      value: undefined as unknown as string | undefined,
      placeholder: undefined as unknown as string | undefined,
      disabled: false,
      readonly: false,
      required: false,
      'data-cy': undefined as unknown as string | undefined,
      dataCy: undefined as unknown as string | undefined,
      error: undefined as unknown as string | undefined,
      touched: false,

      // Event props present for completeness; events are dispatched as CustomEvents
      onInput: undefined as unknown as CustomDatePickerProps['onInput'],
      onChange: undefined as unknown as CustomDatePickerProps['onChange'],
      onBlur: undefined as unknown as CustomDatePickerProps['onBlur'],
      onFocus: undefined as unknown as CustomDatePickerProps['onFocus'],
    },
    CustomDatePicker
  );
}

export type { CustomDatePickerProps };
